<template>
  <Popover :title="title" ref="popover" @show="onPopoverShow" @hide="onPopoverHide">
    <el-radio-group v-model="innerRadio" class="edit-budget">
      <el-radio :label="0"> 不限 </el-radio>
      <el-radio :label="1">
        <el-input-number
          v-model="innerValue"
          controls-position="right"
          :disabled="innerRadio === 0"
          :precision="2"
          :step="1"
          :min="0"
          :max="max"
          style="width: 110px"
        />
      </el-radio>
    </el-radio-group>

    <div style="display: inline-block">
      <el-button type="text" @click="confirm">&ensp;保存</el-button>
    </div>

    <div slot="ref">
      <slot></slot>
    </div>
  </Popover>
</template>

<script>
import Popover from '@/components/popover/index.vue'
import { truncatedNumber } from '@/common/js/utils.js'

export default {
  components: { Popover },
  props: {
    value: [Number, String],
    radio: Number,
    title: String,
    precision: {
      type: Number,
      default: 2
    },
    max: {
      type: Number,
      default: 99999999
    }
  },
  data() {
    return {
      innerValue: '',
      innerRadio: 0
    }
  },
  methods: {
    confirm() {
      this.$emit('update:radio', this.innerRadio)
      this.$emit('input', truncatedNumber(parseFloat(this.innerValue), this.precision))
      this.$refs.popover.close()
    },
    onPopoverShow() {
      if (this.value > 0) {
        this.innerValue = this.value
        this.innerRadio = this.radio
      }
    },
    onPopoverHide() {
      this.innerValue = ''
      this.innerRadio = 0
    },
    trigger() {
      this.$refs.popover.show()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
